import React from 'react';
import TableHead from './TableHead';
import TableBody from './TableBody';

const Table = ({ bills }) => {
    const empty = (bills.length === 0);

    if (empty) {
        return (
            <div className="alert alert-warning rounded-0">
                Nenhum boleto ou guia gerado para esta venda.
            </div>
        );
    }
    return (
        <table className="table align-items-center table-flush">
            <TableHead />
            <TableBody bills={bills} />
        </table>
    );
}

export default Table;



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Bills/Table.js